import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import checkboxIndeterminate from './checkboxIndeterminate.js'
import datetime from './datetime.js'

export default contract({
  checkboxIndeterminate: array([
    checkboxIndeterminate
  ]),
  datetime: array([
    datetime
  ])
})